/* eslint-disable no-useless-concat */
import { useState } from "react";
import { useLoading } from "hooks/useLoading";
import * as DashboardServices from "pages/dashboard/services";
import dayjs from "dayjs";

const utc = require("dayjs/plugin/utc");

dayjs.extend(utc);

const timeValue = {
  allTime: 1,
  yearToDate: 2,
  lastMonth: 3,
  custom: 4,
};

export const timeOptions = [
  { label: "All time", value: timeValue.allTime },
  { label: "Year to date", value: timeValue.yearToDate },
  { label: "Last month", value: timeValue.lastMonth },
  { label: "Custom", value: timeValue.custom },
];

export const transactionTypes = [
  { label: "All transactions", value: "ALL" },
  { label: "Checkouts", value: "PRODUCT_CHECKOUT" },
  // { label: "All outflows", value: 3 },
  { label: "Invoices", value: "INVOICE" },
  // { label: "Refund", value: 5 },
  // { label: "Withdrawals", value: 6 },
];

export function useGenerateReports() {
  const [loading, onLoading, onEnded] = useLoading();

  const [time, setTime] = useState(timeValue.allTime); // Default all time
  const [type, setType] = useState(transactionTypes[0].value); // Default all transactions
  const [value, setValue] = useState([null, null]);
  const isChooseCustom = time === timeOptions[3].value;

  const onChangeTime = (e) => {
    setTime(e.target.value);
  };

  const onChangeType = (e) => {
    setType(e.target.value);
  };

  const JsonToCSV = (data) => {
    let csvData = "Transaction" + "\r\n";
    csvData = csvData + `User,${data.user.email},${data.user.id},` + "\r\n";
    csvData += "Currencies,,";
    if (data.balanceInCurrencies) {
      for (let i = 0; i < data.balanceInCurrencies.length; i++) {
        csvData += `${data.balanceInCurrencies[i].name},`;
      }
      csvData += "USD";
    }
    csvData += "\r\n";
    csvData += `Report start,${dayjs
      .unix(data.report?.startTime)
      .format("YYYY-MM-DD hh:mm:ss")} UTC,`;
    if (data.balanceInCurrencies) {
      for (let i = 0; i < data.balanceInCurrencies.length; i++) {
        csvData += `${data.balanceInCurrencies[i].atStartTime},`;
      }
      csvData += data.equivalentBalanceInUSD.atStartTime;
    }
    csvData += "\r\n";
    csvData += `Report end,${dayjs.unix(data.report?.endTime).format("YYYY-MM-DD hh:mm:ss")} UTC,`;
    if (data.balanceInCurrencies) {
      for (let i = 0; i < data.balanceInCurrencies.length; i++) {
        csvData += `${data.balanceInCurrencies[i].atEndTime},`;
      }
      csvData += data.equivalentBalanceInUSD.atEndTime;
    }
    csvData += "\r\n";
    csvData = csvData + "" + "\r\n";
    csvData =
      csvData +
      `TRANSACTION COMPLETED, TRANSACTION INITIATED, TRANSACTION TYPE, PRODUCT NAME OR INVOICE ID, AMOUNT REQUESTED, TRANSACTION ID CODE, STATUS, ASSET USED FOR PAYMENT, EXCHANGE RATE AT TIME OF TRANSACTION (USD-CRYPTO ASSET), SUBTOTAL IN CRYPTO, SUBTOTAL IN FIAT, ASSET USED FOR FEES, FEE EXCHANGE RATE AT TIME OF TRANSACTION (USD-CRYPTO ASSET), FIZEN FEES IN CRYPTO, FIZEN FEES IN FIAT, NETWORK FEES IN CRYPTO, NETWORK FEES IN FIAT, CONVERSION STATUS, CONVERSION EXCHANGE RATE (USD-CRYPTO ASSET), CONVERTED VALUE IN FIAT, RECEIVER ADDRESS, ETHEREUM HOMESTEAD ADDRESS, METADATA, TRANSACTION HASH` +
      "\r\n";
    if (data.paymentRecords.length > 0) {
      for (let i = 0; i < data.paymentRecords.length; i++) {
        const rpData = data.paymentRecords[i];
        csvData += `${dayjs(rpData.initedAt).format("YYYY-MM-DD hh:mm:ss")},${dayjs(
          rpData.confirmedAt,
        ).format("YYYY-MM-DD hh:mm:ss")},${rpData.transactionType},${rpData.productName},${
          rpData.amountRequested
        }${rpData.localCurrency},${rpData.transactionIdCode},${rpData.paymentStatus},${
          rpData.assetUsedForPayment
        },${rpData.exchangeRateByUSDAtTransfer},${rpData.subTotalInCrypto},${
          rpData.subTotalInFiat
        },${rpData.assetUsedForFee},${rpData.exchangeRateByUSDAtTransfer},${
          rpData.fizenpayFeeInCrypto
        },${rpData.fizenpayFeeInFiat},"","","","","","","",name=>${rpData.metadata?.name} email=>${
          rpData.metadata?.email
        },${rpData.transactionHash}`;
        csvData += "\r\n";
      }
    }
    csvData += "\r\n";

    console.log({ csvData });
    let fileName = data.report?.name ?? "Report";

    //Initialize file format you want csv or xls
    let uri = "data:text/csv;charset=utf-8," + escape(csvData);
    let link = document.createElement("a");
    link.href = uri;
    link.style = "visibility:hidden";
    link.download = fileName + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onGenerateReport = async () => {
    try {
      onLoading();
      let reportData;
      if (time === timeValue.allTime) {
        reportData = {
          startTime: 1,
          endTime: dayjs().unix() * 1000, // convert to milliseconds
          transactionType: type,
        };
      } else if (time === timeValue.yearToDate) {
        reportData = {
          startTime: dayjs().startOf("year").unix() * 1000,
          endTime: dayjs().unix() * 1000,
          transactionType: type,
        };
      } else if (time === timeValue.lastMonth) {
        reportData = {
          startTime: dayjs().subtract(1, "month").unix() * 1000,
          endTime: dayjs().unix() * 1000,
          transactionType: type,
        };
      } else if (time === timeValue.custom) {
        if (value[0] && value[1]) {
          reportData = {
            startTime: value[0].unix() * 1000,
            endTime: value[1].add(1, "day").unix() * 1000,
            transactionType: type,
          };
        }
      }

      console.log(reportData);

      if (reportData) {
        const res = await DashboardServices.generateReport(reportData);
        console.log(res);
        JsonToCSV(res.data);
        // console.log(res.data.report.startTime)
        // console.log(dayjs.unix(res.data.report?.startTime).utc().format())
        // console.log(dayjs.unix(res.data.report?.startTime).format())
        // const date = dayjs().unix()
        // const d = dayjs()
        // console.log({ date, day: dayjs(date).toISOString(), d: d.toISOString() })
        // console.log(new Date().getSeconds())
      }
    } catch (err) {
    } finally {
      onEnded();
    }
  };

  return {
    time,
    type,
    onChangeTime,
    onChangeType,
    value,
    setValue,
    isChooseCustom,
    onGenerateReport,

    loading,
  };
}
